import React from "react";
import { Col, Row, Input, UncontrolledTooltip } from "reactstrap";
import moment from "moment";
import ToolkitProvider, { CSVExport } from "react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import { toFloat } from "validator";
import {
  Button
} from "reactstrap";
import { useTranslation } from "react-i18next";


const EscrowRefundsTable = ({ tableData, searchQuery, defaultSorted }) => {
  const { ExportCSVButton } = CSVExport;
  const { t } = useTranslation();
  const dateFormatter = (cell, row) => {
    return (
      moment(cell).format('YYYY-MM-DD')
    );
  };

  const amountFormatter = (cell, row) => (
    <b>{toFloat(cell).toFixed(0)} €</b>
  );


  const statusFormatter = (cell, row) => {
    const tooltipId = `status-tooltip-${row.id}`;

    let label, color, tip;
    switch (cell) {
      case "pending":
        label = t("escrowWallet.view.escrowRefunds.table.label.pending");
        color = "warning";
        tip = t("escrowWallet.view.escrowRefunds.table.tooltip.pending");;
        break;
      case "approved":
        label = t("escrowWallet.view.escrowRefunds.table.label.approved");
        color = "primary";
        tip   = t("escrowWallet.view.escrowRefunds.table.tooltip.approved");
        break;
      case "rejected":
        label = t("escrowWallet.view.escrowRefunds.table.label.rejected");
        color = "danger";
        tip = row.comments || t("escrowWallet.view.escrowRefunds.table.tooltip.rejected");
        break;
      default:
        label = t("escrowWallet.view.escrowRefunds.table.label.pending");
        color = "warning";
        tip = t("escrowWallet.view.escrowRefunds.table.tooltip.approved");
    }
    return (
      <>
        <Button id={tooltipId} className="btn-status" disabled color={color}>
          {label}
        </Button>
        {tip && (
          <UncontrolledTooltip
            placement="top"
            target={tooltipId}
            trigger="hover"
          >
            {tip}
          </UncontrolledTooltip>
        )}
      </>
    );
  };

  const columns = [
    {
      dataField: "refund_id",
      text: t("escrowWallet.view.escrowRefunds.table.column.refundId"),
      sort: false,
      headerStyle: () => ({ width: "120px" }),
    },
    {
      dataField: "escrow_payment_id",
      text: t("escrowWallet.view.escrowRefunds.table.column.paymentId"),
      sort: false,
      headerStyle: () => ({ width: "120px" }),
    },
    {
      dataField: "release",
      text: t("escrowWallet.view.escrowRefunds.table.column.release"),
      sort: false,
      headerStyle: () => ({ width: "120px" })
    },
    {
      dataField: "amount",
      text: t("escrowWallet.view.escrowRefunds.table.column.amount"),
      formatter: amountFormatter,
      csvFormatter: amountFormatter,
      sort: false,
      headerStyle: () => ({ width: "120px" })
    },
    {
      dataField: "created",
      text: t("escrowWallet.view.escrowRefunds.table.column.requestDate"),
      formatter: dateFormatter,
      csvFormatter: dateFormatter,
      sort: true,
      headerStyle: () => ({ width: "120px" })
    },
    {
      dataField: "status",
      text: t("escrowWallet.view.escrowRefunds.table.column.status"),
      formatter: statusFormatter,
      csvFormatter: statusFormatter,
      sort: true,
      headerStyle: () => ({ width: "120px" })
    },
    {
      dataField: "release",
      sort: false,
      csvExport: false,
      hidden: true,
    }
  ];

  const handleTableChange = (type, { sortField, sortOrder }) => {
    const ascDesc = sortOrder === "desc" ? "-" : "";
    if (sortField === "created") {
      searchQuery.setOrdering({ order: ascDesc, name: sortField, sort: sortField });
    }
  };

  return (
    <ToolkitProvider
      keyField="id"
      data={tableData}
      columns={columns}
      search={{
        searchFormatted: true
      }}
      exportCSV={{ fileName: "escrow-refunds.csv" }}
    >
      {props => (
        <div>
          <Row>
            <Col>
              <div className="customSearch">
                <Input
                  placeholder={t("escrowWallet.view.escrowRefunds.table.placeholder.search")}
                  value={searchQuery.query}
                  style={{ marginBottom: 10 }}
                  onChange={e => searchQuery.setQuery(e.target.value)}
                />
              </div>
            </Col>

            <Col>
              <div className="flexEndContainer">
                <ExportCSVButton className="btn btn-outline-info" {...props.csvProps}>
                  {t("escrowWallet.view.escrowRefunds.table.button.exportCsv")}
                </ExportCSVButton>
              </div>
            </Col>
          </Row>
          <BootstrapTable
            {...props.baseProps}
            bordered={false}
            remote={{ sort: true }}
            defaultSorted={defaultSorted}
            onTableChange={handleTableChange}
          />
        </div>
      )}
    </ToolkitProvider>
  );
};

export default EscrowRefundsTable;